import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';

import LotToDo from './LotToDo';
import style from './style';

const HowItAllStarted = ({ data }) => {
  const classes = style();

  return (
    <Box className={classes.segment}>
      <Container>
        <Typography paragraph align="center" variant="h2">
          {data?.title}
        </Typography>
        <Grid container spacing={3} justifyContent={'center'}>
          <Grid item xs={12} md={9}>
            <div className={classes.contentText}>
              {data.contents.map((content, key) => {
                return (
                  <Typography variant="h6" paragraph key={key}>
                    {content}
                  </Typography>
                );
              })}
            </div>
            <LotToDo data={data?.lotToDo} />

            <Box
              sx={{
                mt: {
                  xs: 4,
                  md: 8,
                },
              }}
            />
            <Typography align="center">{data?.lotToDo?.para}</Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default HowItAllStarted;
